import { Link } from 'react-router-dom';
import {
  IconChart,
  IconInventory,
  IconOrders,
  IconProcurement,
  IconReport,
} from '../../components/icons';
import { PageHeader, panelClassName } from '../../components/ui';

const REPORT_LINKS = [
  {
    id: 'purchase-shipping',
    title: 'Purchase Shipping',
    description:
      'Export IN order lines in MAR Express Excel format — filters for All / One day / Custom and Shipped / Delivered.',
    to: '/admin/reports/purchase-shipping',
    icon: IconReport,
  },
  {
    id: 'batch',
    title: 'Batch report',
    description:
      'Download procurement batch data — Batch ID, buy qty/total, tracking, HAWB, confirm status — styled Excel export.',
    to: '/admin/reports/batch',
    icon: IconProcurement,
  },
  {
    id: 'analytics',
    title: 'Operations analytics',
    description: 'KPIs across orders, procurement, and inventory for the selected date range.',
    to: '/admin/analytics',
    icon: IconChart,
  },
  {
    id: 'orders',
    title: 'Orders report',
    description: 'Browse and filter synced Amazon US & IN order history.',
    to: '/admin/orders',
    icon: IconOrders,
  },
  {
    id: 'inventory',
    title: 'Inventory report',
    description: 'Stock on hand, reorder levels, and supplier-linked items.',
    to: '/admin/inventory',
    icon: IconInventory,
  },
];

function ReportsPage() {
  return (
    <section className="grid gap-5 min-w-0 w-full">
      <PageHeader
        title="Reports"
        subtitle="Open operational reports across orders, procurement, inventory, and analytics."
      />

      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-2">
        {REPORT_LINKS.map((report) => {
          const Icon = report.icon;
          return (
            <Link
              key={report.id}
              to={report.to}
              className={`${panelClassName} group flex items-start gap-4 px-5 py-4 transition hover:border-slate-300 hover:shadow-sm`}
            >
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-slate-100 text-slate-700 transition group-hover:bg-blue-50 group-hover:text-blue-700">
                <Icon className="h-5 w-5" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-slate-900">{report.title}</h3>
                  <IconReport className="h-3.5 w-3.5 text-slate-300" />
                </div>
                <p className="mt-1 text-sm leading-relaxed text-slate-500">{report.description}</p>
                <span className="mt-3 inline-flex text-xs font-semibold text-blue-600 group-hover:underline">
                  Open report →
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default ReportsPage;
